<template>
	<section class="listTvChannels">
		<h2 v-if="content.header">{{ content.header }}</h2>
		<div
			class="ingress"
			v-if="content.ingress"
			v-html="content.ingress"
		></div>
		<LazyTvChannels
			v-if="isTvChannels"
			:channel="content.channel"
			:jsonUrl="metadata.jsonUrl"
			:designOptions="designOptions"
		/>
		<LazyTweChannels
			v-if="isTweChannels"
			:listOptions="metadata.listOptions"
		/>
	</section>
</template>

<script>
import GizmoComponentMixin from "../../../mixins/platform/GizmoComponentMixin.js";

export default defineNuxtComponent({
	name: "ListTvChannels",

	mixins: [GizmoComponentMixin],

	computed: {
		isTvChannels() {
			return this.content.channel || this.metadata.jsonUrl;
		},
		isTweChannels() {
			return this.metadata.listOptions;
		},
		designOptions() {
			const opts = this.metadata.designOptions || [];
			return {
				big: opts.some((opt) => opt === "Use big channel cards"),
				hideName: opts.some((opt) => opt === "Hide channel name under logo"),
			};
		},
	},
});
</script>

<style lang="scss" scoped>
.container-listtv-override {
	// Override col class to make the information box go full width
	position: inherit !important;

	@include breakpoint(mobile) {
		padding: 0;
	}
}

.listTvChannels {
	:deep(h2) {
		margin: 0 0 $spacing-xl;
		font-weight: normal;

		@include font-title-xl;
	}

	:deep(.ingress) {
		margin-bottom: $spacing-xl;

		@include font-text-m;
	}
}
</style>
